import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import { history } from './createStore';
import ScrollToTop from './scrollToTop';
import { browserName } from 'react-device-detect';
import BrowserWarning from './views/BrowserWarning';
import { BrowserRouter } from 'react-router';

export default function getRoot(store) {
  const isIEBrowser = browserName === 'IE';
  return isIEBrowser ? (
    <BrowserWarning />
  ) : (
    <div>
      <Provider store={store}>
        <BrowserRouter history={history}>
          <ScrollToTop>
            <App history={history}/>
          </ScrollToTop>
        </BrowserRouter>
      </Provider>
    </div>
  );
}
